export default class ProjectUtil {
  static totalHours(modules, columns) {
    var total = 0
    for (var module in modules) {
      for (var component in modules[module].components) {
        var componentTotal = 0
        var totalPercent = 0
        var quantity = modules[module].components[component].moduleColumns.metaElements[modules[module].components[component].moduleColumns.metaElements.length - 1]

        for (var element in modules[module].components[component].moduleColumns.hourlyElements) {
          componentTotal += modules[module].components[component].moduleColumns.hourlyElements[element]['mid']
        }

        for (var element in modules[module].components[component].moduleColumns.percentTasks) {
          var percent = modules[module].components[component].moduleColumns.percentTasks[element]['mid']
          totalPercent = totalPercent + percent
        }
        total = total + (componentTotal * (1 + (totalPercent/100))) * quantity['mid']
      }
    }
    return new Intl.NumberFormat('en-US', { minimumFractionDigits: 1 }).format(total)
  }

  static totalPrice(modules, columns, rate) {
    var totalPrice = 0
    for (var m_key in modules) {
      for (var c_key in modules[m_key].components) {
        const component = modules[m_key].components[c_key]
        totalPrice += this.componentPrice(component, columns, rate)
      }
    }
    return totalPrice
  }

  static totalPriceWithOverrides(modules, columns, rate, overrides) {
    const totalPrice = this.totalPrice(modules, columns, rate) 
    return totalPrice + this.totalOverridePrice(overrides, totalPrice)
  }

  static totalOverridePrice(overrides, projectTotalPrice) {
    let total = 0
    for (var key in overrides) {
      if (overrides[key].type == 'fixed') {
        total += parseFloat(overrides[key].value)
      } else if (overrides[key].type == 'percent') {
        total += projectTotalPrice * parseFloat(overrides[key].value)/100
      }
    }
    return total
  }

  static overrideByKey(key, overrides, projectTotalPrice) {
    if (overrides[key].type == 'fixed') {
      return parseFloat(overrides[key].value)
    } else if (overrides[key].type == 'percent') {
      return projectTotalPrice * parseFloat(overrides[key].value)/100
    }
    return 0
  }

  static componentPrice(component, columns, rate) {
    var componentTotal = 0
    var hoursTotal = 0
    const selectedPriceRange = 'mid'
    var quantity = component.moduleColumns.metaElements[component.moduleColumns.metaElements.length - 1][selectedPriceRange]

    // hourly task price 
    for (var element in component.moduleColumns.hourlyElements) {
      if (!columns.hourlyElements[element].disabled) {
        var hours = component.moduleColumns.hourlyElements[element][selectedPriceRange]
        if ((columns.hourlyElements[element] ? columns.hourlyElements[element].hourlyRateOverride : false) && columns.hourlyElements[element].useTaskRate == true) {
          // console.log('hours', hours)
          componentTotal = componentTotal + quantity * hours * columns.hourlyElements[element].hourlyRateOverride
          hoursTotal = hoursTotal + hours * quantity
        } else {
          componentTotal = componentTotal + quantity * hours * rate
          hoursTotal = hoursTotal + hours * quantity
        }
      }
    }
    // percen task price
    const startingTotal = hoursTotal

    for (var element in component.moduleColumns.percentTasks) {
      if (columns.percentTasks[element].disabled == true) {
      } else {

        var percent = columns.percentTasks[element].taskPercentOverride || 0

        // console.log('test', columns.percentTasks[element])
        if (component.moduleColumns.percentTasks[element][selectedPriceRange]) {
          percent = component.moduleColumns.percentTasks[element][selectedPriceRange]
        }

        var _rate = rate

        if (columns.percentTasks[element].hourlyRateOverride && columns.percentTasks[element].useTaskRate) {
          _rate = columns.percentTasks[element].hourlyRateOverride
        }
        var addToTotal = startingTotal * (percent/100) * _rate
        componentTotal = componentTotal + addToTotal
      }
    }
    // fixed task price
    for (var element in component.moduleColumns.fixedElements) {
      if (columns.fixedElements[element].disabled == true) {
      } else {
        var amount = component.moduleColumns.fixedElements[element][selectedPriceRange]
        componentTotal = componentTotal + quantity * amount
      }
    }
    return componentTotal
  }

  static priceFormatterValue(value) {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    })
    return formatter.format(value)
  }
}
